var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgencyDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13892 5.83317H12.0834M5.13892 9.99983H12.0834M5.13892 14.1665H9.30562M12.7779 18.3332H18.3334V14.1665L15.5555 11.3886M12.7779 18.3332V14.1665L15.5555 11.3886M12.7779 18.3332L3.05546 18.3332C2.28844 18.3332 1.66669 17.7114 1.66669 16.9444V3.05527C1.66669 2.28825 2.28844 1.6665 3.05546 1.6665H14.1669C14.9339 1.6665 15.5556 2.28825 15.5556 3.05527L15.5555 11.3886",
    stroke: "#706F7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyDetail);
export default __webpack_public_path__ + "static/media/agencyDetail.54b47f29216f12603777a7a2ad1c4496.svg";
export { ForwardRef as ReactComponent };